export default {
  anchorEditor: true,
  anchorPreview: true,
  attributeInserter: false,
  textFormatter: true,
  allowMention: false,
  allowAlignment: true,
  allowAttachments: false,
  allowAttribute: false,
  allowBold: true,
  allowItalic: true,
  allowAnchor: true,
  allowHeading: true,
  allowSubheading: true,
  allowOrderedList: true,
  allowUnorderedList: true,
  allowImage: true,
  allowButton: true,
  allowVideo: true,
  allowSocial: false,
  allowCode: true,
  allowHtml: false,
  allowEmoji: true,
  allowRtl: true,
  readOnly: false,
  displaySocialBlocksAsButtons: false,
  urlReplacement: true,
  // Perform automatic conversion of URLs to anchors
  markdownLinks: true,
  // Convert markdown links to anchors
  markdownInlineCode: true,
  autoFocusTopLeft: true,
  recoverErrors: false,
  stripEmptyTrailingBlocks: false
};